import { createUseDateRangeFilter } from '@/creditflowresearch/ui/common/hooks/sidebar/useDateRangeFilter';
import {
  useCorporateBondScreenerSidebarFilterContext,
} from '@/creditflowresearch/application/CorporateBondScreener/Sidebar/useCorporateBondScreenerSidebarFilterContext';

const useDateRangeFilter = createUseDateRangeFilter(useCorporateBondScreenerSidebarFilterContext);

const useCallDate = () => {
  const { filters } = useCorporateBondScreenerSidebarFilterContext();

  return useDateRangeFilter({
    fromKey: 'includedCallDateFrom',
    toKey: 'includedCallDateTo',
    bounds: filters?.callDate,
  });
};

export default useCallDate;
